import React, { useState } from "react";
import "./PersonalCard.css";

const PersonalCard = ({
  photourl,
  name,
  introduction,
  mainTakeaways,
  fulltext,
  handleClose,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`personal-card ${isCollapsed ? "" : "expanded"}`}>
      <div className="close-button" onClick={handleClose}>
        X
      </div>
      <div className="frame">
        <img className="photo" src={photourl} alt={`${name}'s`} />
      </div>
      <div className="content-personalcard">
        <h2> {name} </h2>
        <p>{introduction}</p>
        <ul className="takeaway-list">
          {mainTakeaways.map((takeaway, index) => (
            <li key={index}>{takeaway}</li>
          ))}
        </ul>

        <button className="read-more-btn" onClick={handleToggle}>
          {isCollapsed ? "Read More" : "Close"}
        </button>
        <div
          className={`collapsible-content ${isCollapsed ? "collapsed" : ""}`}
        >
          {fulltext}
        </div>
      </div>
    </div>
  );
};

export default PersonalCard;
